import React from "react";
import { Form, Row, Col, Button, InputGroup, Offcanvas } from "react-bootstrap";

import Select from "react-select";
import Flatpickr from "react-flatpickr";
import { useDispatch, useSelector } from "react-redux";
import {
  setPaginationPageNumber,
  setActiveTab,
  TriggerFilterButtonApi,
} from "../../../slices/common/reducer";
import { setOrderFilterForm } from "../../../slices/orders/orderSlice";
import {
  filterDateOptions,
  handleFilterDateChange,
  removeEmptyKeysFromState,
} from "../../../Utils/CommonUtils";
import { ORD_FROM_DATE, ORD_TO_DATE } from "../../../Utils/FilterDateKeys";
import { CiSearch } from "react-icons/ci";
import { getFilteredDataWithTabs } from "../../../Utils/CommonService";
import { setProductData } from "../../../slices/product/productSlice";
import { useEffect } from "react";
import { setUsersData } from "../../../slices/team/users/usersSlice";
import { useState } from "react";
import { useMemo } from "react";
import "./Order.scss";
import { setAffinityGroupData } from "../../../slices/ag/affinityGroup/affinityGroupSlice";
import { getRMList } from "./OrderService";

const AdvancedFilter = ({ show, onClose }) => {
  const dispatch = useDispatch();
  const filterForm = useSelector((state) => state.order.filter.form);
  const selectedUser = useSelector((state) => state.header.selectedUser);
  const organizationId = selectedUser.organizationid;
  const enterpriseid = localStorage.getItem("enterpriseid");
  const usersData = useSelector((state) => state.users.usersData);
  const productData = useSelector((state) => state.product.productData);
  const filterApi = useSelector((state) => state.order.filter.filterApi);
  const filterFormChanged = useSelector(
    (state) => state.order.filter.isFormChanged
  );
  const userid = localStorage.getItem("userId");
  const affinityGroupData = useSelector(
    (state) => state.affinityGroup.affinityGroupData
  );
  const agId =
    selectedUser.entitytype === "AGRP" ? selectedUser.entityid : null;
  const rmData = useSelector((state) => state.order.rmData);

  const resetTabAndPageNumber = () => {
    dispatch(setPaginationPageNumber(0));
    dispatch(setActiveTab("ALL"));
  };

  // const handleInputChange = (name, value) => {
  //   // dispatch(setOrderFilterForm({ name, value }));
  //   // resetTabAndPageNumber();
  //   // dispatch(TriggerFilterButtonApi());
  // };

  const handleApply = () => {
    dispatch(TriggerFilterButtonApi());
    onClose();
  };

  useEffect(() => {
    dispatch(setOrderFilterForm({ type: "reset" }));
  }, []);

  const handleClear = () => {
    dispatch(setOrderFilterForm({ type: "reset" }));

    if (!filterApi) return;

    dispatch(TriggerFilterButtonApi());

    if (Object.keys(filterForm).length > 0) {
      resetTabAndPageNumber();
    }
  };

  const orderOptions = [
    { value: "PAYMENT_SUCCESS", label: "Payment Success" },
    { value: "PAYMENT_FAILED", label: "Payment Failed" },
    { value: "PAYMENT_PENDING", label: "Payment Pending" },
    // { value: "PROPOSAL_PENDING", label: "Proposal Pending" },
    { value: "CANCELLED", label: "Cancelled" },
    { value: "COMPLETED", label: "Completed" },
  ];

  const orderTypeOption = [
    { value: "FRESH", label: "Fresh" },
    { value: "RENEWAL", label: "Renewal" },
  ];

  const policyStatus = [
    { value: "AWAITED_UNDERWRITING", label: "AWAITED UNDERWRITING" },
    { value: "DETAILS_AWAITED", label: "DETAILS AWAITED" },
    { value: "REJECTED", label: "REJECTED" },
    { value: "ISSUED", label: "ISSUED" },
  ];

  const renewalOptions = [
    { value: "TO_BE_RENEWED", label: "TO BE RENEWED" },
    { value: "RENEWAL_IN_GRACE", label: "RENEWAL IN GRACE" },
    { value: "RENEWED", label: "RENEWED" },
    { value: "RENEWAL_LAPSED", label: "RENEWAL LAPSED" },
  ];

  const isClearButtonDisabled = !Object.values(filterForm).some(
    (value) => value
  );

  const userOptions = usersData.map((item) => {
    return {
      value: item.name,
      label: item.name,
    };
  });

  const agOptions = affinityGroupData.map((item) => {
    return {
      value: item.name,
      label: item.name,
    };
  });

  const productOptions = productData.map((item) => {
    return {
      value: item.name,
      label: item.name,
    };
  });

  const rmOptions = rmData.map((item) => {
    return {
      value: item.name,
      label: item.name,
    };
  });

  const memberParams = useMemo(
    () => ({
      page: 0,
      size: 50,
      sort_column: "created_date",
      sort_order: "ASC",
      listEntityType: "AGSU",
    }),
    []
  );
  const productParams = useMemo(
    () => ({
      page: 0,
      size: 50,
      sort_column: "created_date",
      sort_order: "ASC",
      listEntityType: "AGRP",
    }),
    []
  );

  const agParams = useMemo(
    () => ({
      page: 0,
      size: 50,
      sort_column: "created_date",
      sort_order: "ASC",
      listEntityType: "AGRP",
    }),
    []
  );

  useEffect(() => {
    const fetchProductAndCustomer = async () => {
      try {
        // Fetch AGSU data
        console.log("Calling AGSU...");
        await getFilteredDataWithTabs(
          "PPET",
          setProductData,
          {},
          productParams,
          "ALL",
          null,
          organizationId,
          null,
          enterpriseid,
          null,
          null,
          null,
          null,
          null,
          null
          // agId
        );
        await new Promise((resolve) => setTimeout(resolve, 1000));

        // Fetch PPET data
        console.log("Calling PPET...");
        await getFilteredDataWithTabs(
          "AGSU",
          setUsersData,
          {},
          memberParams,
          "ALL",
          null,
          organizationId,
          null,
          enterpriseid,
          null,
          null,
          organizationId,
          null,
          null,
          null,
          null
        );
        await new Promise((resolve) => setTimeout(resolve, 1000));

        // Fetch PPET data
        console.log("Calling PPET...");
        await getFilteredDataWithTabs(
          "AGRP",
          setAffinityGroupData,
          {},
          agParams,
          "ALL",
          null,
          null,
          null,
          enterpriseid,
          userid,
          "AG",
          null,
          null,
          null,
          null,
          null
        );
        await new Promise((resolve) => setTimeout(resolve, 1000));
        getRMList();
      } catch (error) {
        console.error("Error fetching product or customer data:", error);
      }
    };

    if (show) {
      fetchProductAndCustomer();
    }
  }, [show, organizationId, enterpriseid, memberParams, productParams]);

  return (
    <Offcanvas show={show} onHide={onClose} placement="end">
      <div className="advance-filter-container">
        <Offcanvas.Header className="offcanvas--header" closeButton>
          <Offcanvas.Title>Order Filters</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form className="offcanvas-container">
            <Form.Group className="form-css">
              <Form.Label>Product</Form.Label>
              <Select
                isClearable
                placeholder="Status"
                name="name"
                options={productOptions}
                value={
                  productOptions?.filter(
                    (itm) => itm?.value === filterForm?.name
                  ) || ""
                }
                onChange={(e) => {
                  dispatch(
                    setOrderFilterForm({
                      name: "name",
                      value: e?.value,
                    })
                  );
                }}
              />
            </Form.Group>
            <Form.Group className="form-css">
              <Form.Label htmlFor="filter_ref">Relationship Manager</Form.Label>
              <Select
                isClearable
                placeholder="Status"
                name="rm_name"
                options={rmOptions}
                value={
                  rmOptions?.filter(
                    (itm) => itm?.value === filterForm?.rm_name
                  ) || ""
                }
                onChange={(e) => {
                  dispatch(
                    setOrderFilterForm({
                      name: "rm_name",
                      value: e?.value,
                    })
                  );
                }}
              />
            </Form.Group>
            <Form.Group className="form-css">
              <Form.Label htmlFor="filter_ref">Order Type</Form.Label>
              <Select
                isClearable
                placeholder="Status"
                name="order_type"
                options={orderTypeOption}
                value={
                  orderTypeOption?.filter(
                    (itm) => itm?.value === filterForm?.order_type
                  ) || ""
                }
                onChange={(e) => {
                  dispatch(
                    setOrderFilterForm({
                      name: "order_type",
                      value: e?.value,
                    })
                  );
                }}
              />
            </Form.Group>
            <Form.Group className="form-css">
              <Form.Label htmlFor="filter_ref">Renewal Status</Form.Label>

              <Select
                isClearable
                placeholder="Order Status"
                name="renewal_status"
                options={renewalOptions}
                value={
                  renewalOptions?.filter(
                    (itm) => itm?.value === filterForm?.renewal_status
                  ) || ""
                }
                onChange={(e) => {
                  dispatch(
                    setOrderFilterForm({
                      name: "renewal_status",
                      value: e?.value,
                    })
                  );
                }}
              />
            </Form.Group>
            <Form.Group className="form-css">
              <Form.Label htmlFor="filter_ref">AG</Form.Label>

              <Select
                isClearable
                placeholder="AG"
                name="ag_name"
                options={agOptions}
                value={
                  agOptions?.filter(
                    (itm) => itm?.value === filterForm?.ag_name
                  ) || ""
                }
                onChange={(e) => {
                  dispatch(
                    setOrderFilterForm({
                      name: "ag_name",
                      value: e?.value,
                    })
                  );
                }}
              />
            </Form.Group>
            <Form.Group className="form-css">
              <Form.Label htmlFor="filter_ref">Policy Status</Form.Label>

              <Select
                isClearable
                placeholder="Order Status"
                name="policy_status"
                options={policyStatus}
                value={
                  policyStatus?.filter(
                    (itm) => itm?.value === filterForm?.policy_status
                  ) || ""
                }
                onChange={(e) => {
                  dispatch(
                    setOrderFilterForm({
                      name: "policy_status",
                      value: e?.value,
                    })
                  );
                }}
              />
            </Form.Group>
          </Form>
        </Offcanvas.Body>
        {/* Footer Section */}
        <div className="offcanvas--footer">
          <Button className="primary-outline clear" onClick={handleClear}>
            Clear
          </Button>
          <Button className="primary_button apply" onClick={handleApply}>
            Apply
          </Button>
        </div>
      </div>
    </Offcanvas>
  );
};

export default AdvancedFilter;
